import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { GoogleIntegrationService } from '../../../../services/google-integration.service';
import GoogleIntegrationDetails from '../../../../shared/models/google/google-integration-details';
import { TabPanelDisplayMode } from 'app/components/enums/TabPanelDisplayMode';
import CustomerAccountTypes = Boo.Objects.Enums.CustomerAccountTypes;
import TaskTypeEnum = Boo.Objects.Enums.TaskTypeEnum;

@Component({
  selector: 'app-components-specialist-actioncomponents-google-integration-setup',
  templateUrl: './google-integration-setup.component.html',
  styleUrls: ['./google-integration-setup.component.scss']
})
export class GoogleIntegrationSetupComponent implements OnInit, IActionWorkspace {
  isLoading = false;
  actionViewModel: KnockoutObservable<IActionWorkspace>;
  currentAction: KnockoutObservable<Boo.Objects.Action>;
  customerId: number;
  taskId: number;
  taskDescription: string;
  details: GoogleIntegrationDetails = {} as GoogleIntegrationDetails;
  tabPanelDisplayMode = TabPanelDisplayMode;
  accountTypes = [
    CustomerAccountTypes.CMSAdminAccess,
  ]
  checked = false;
  verified = false;
  hasFailedVerification = false;
  isRedo = false;

  constructor(private googleIntegrationService: GoogleIntegrationService) { }

  canActivate(user: Boo.Objects.User, partner: Boo.Objects.Partner, params: IActionWorkspaceActivationParams): boolean | JQueryPromise<boolean> {
    this.currentAction = params.currentAction;
    this.customerId = params.currentAction().Task.CustomerId;
    this.taskId = params.currentAction().Task.TaskId;
    params.controlViewModel(this);
    return true;
  }

  ngOnInit(): void {
    this.isRedo = this.currentAction().Task.TaskTypeEnum === TaskTypeEnum.GoogleIntegrationSetupRedo;
    this.taskDescription = this.currentAction().Task.TaskTypeSummary.Tips;
    this.isLoading = true;

    this.googleIntegrationService.getDetails(this.customerId)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: details => this.details = details,
        error: err => toastr.error('Error fetching Google integration details:', err)
      });
  }

  verifyGtmTag(): void {
    this.isLoading = true;
    this.checked = true;
    this.googleIntegrationService.verifyGtmTag(this.customerId)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: isVerified => {
          this.verified = isVerified;
          this.hasFailedVerification ||= !isVerified;
        },
        error: error => {
          this.verified = false;
          this.hasFailedVerification = true;
        }
      });
  }

  isStepReadyToReject(): boolean {
    return false;
  }

  isStepReadyToSave(): boolean {
    return true;
  }

  isStepReadyToComplete(): boolean {
    if (!this.verified) {
      toastr.error('Search Console verification has not passed. Use Verify Analytics and Search Console Installation to re-check before completing the task.');
      return false;
    }
    return true;
  }

  isStepReadyToDelete(): boolean {
    return false;
  }
}
